export class InvMasterModel{
    id:number;
    code:string;
    description: string;
    type:string;
    pallet:string;
    constructor(){}
}